import React from 'react';
import PropTypes from 'prop-types';

export const TriangleIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    className={className}
  >
    <path
      stroke="#3E3E3E"
      d="M6.7 4.528l7.85 2.153a1.5 1.5 0 01.618 2.551L8.79 15.086a1.5 1.5 0 01-2.49-.834L4.83 6.246A1.5 1.5 0 016.7 4.528z"
    />
  </svg>
);

TriangleIcon.propTypes = {
  className: PropTypes.string,
};

TriangleIcon.defaultProps = {
  className: '',
};

export const CircleIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="7"
    fill="none"
    viewBox="0 0 7 7"
    className={className}
  >
    <circle cx="3.5" cy="3.5" r="3" stroke="#3E3E3E" />
  </svg>
);

CircleIcon.propTypes = {
  className: PropTypes.string,
};

CircleIcon.defaultProps = {
  className: '',
};

export const WaveIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="18"
    fill="none"
    viewBox="0 0 35 18"
    className={className}
  >
    <path
      fill="#00D6C8"
      d="M2.313 16.622c-.118-1.584.254-3.167 1.079-4.59.091-.157.193-.308.306-.454 0 0 .227-.26.11-.138a2.809 2.809 0 01.426-.367c-.11.075.046-.026.058-.034a9.51 9.51 0 01.291-.143c.248-.115-.138.015.132-.042l.306-.07c.218-.048.074-.014.019 0a3.69 3.69 0 01.613 0c.052 0 .306.028.082 0a6.045 6.045 0 01.947.216c.202.062-.233-.102.101.034.104.041.206.085.306.132.172.079.337.165.5.261l.19.112c.288.177-.135-.115.125.089.193.148.386.294.57.45.64.55 1.198 1.163 1.777 1.76 1.195 1.237 2.61 2.396 4.495 2.798a5.326 5.326 0 002.747-.102c.881-.273 1.642-.77 2.18-1.425 1.1-1.277 1.363-2.932 1.55-4.464.199-1.633.23-3.223.78-4.797a5.563 5.563 0 011.04-1.876c.045-.054.091-.112.14-.166-.116.13.135-.13.123-.123a5.153 5.153 0 01.668-.552c-.04.028-.154.088.033-.018.185-.11.376-.21.573-.3.34-.155.706-.264 1.085-.323.021 0 .377-.05.129-.026.107 0 .217-.016.327-.021h.273c.046 0 .423.029.178 0 .213.03.424.073.63.128.307.073-.097-.047.077.02.117.047.23.1.34.154.414.214.742.49 1.198.782.852.545 1.901.822 2.966.782 1.066-.04 2.082-.394 2.874-1.001a.9.9 0 00.308-.683.912.912 0 00-.336-.674 1.256 1.256 0 00-.792-.286 1.269 1.269 0 00-.804.262c-.257.195.175-.078-.113.083l-.236.123a4.31 4.31 0 01-.248.11c.208-.081-.126.03-.138.033l-.215.052c-.021 0-.38.055-.131.029a4.763 4.763 0 01-.668 0c-.343-.016.12.026-.08 0-.089-.018-.18-.034-.27-.055a3.005 3.005 0 01-.306-.091c.172.063 0 0-.027-.02a10.711 10.711 0 01-1.02-.64A5.555 5.555 0 0027.082.544a6.55 6.55 0 00-2.757.245c-1.745.58-3.15 1.724-3.906 3.182-.849 1.563-1.119 3.236-1.293 4.932-.089.863-.153 1.78-.306 2.606a8.92 8.92 0 01-.243 1.003 6.178 6.178 0 01-.156.453l-.113.26c-.117.261.095-.15-.055.113-.09.151-.175.302-.28.448-.045.065-.091.13-.14.193 0 .015-.227.245-.077.091a3.6 3.6 0 01-.358.326c-.052.039-.104.078-.16.114.181-.12-.162.081-.198.1a3.39 3.39 0 01-.19.085c.199-.083-.138.042-.154.045-.11.028-.22.05-.334.07-.036 0-.22.018-.033 0-.191.01-.382.01-.573 0-.34-.013.18.05-.153-.018-.114-.024-.227-.042-.34-.068a5.522 5.522 0 01-1.973-.972 18.06 18.06 0 01-1.888-1.824C10.205 10.68 8.894 9.52 7.034 9.025a5.693 5.693 0 00-3.014-.019c-1.065.345-1.946 1.006-2.482 1.86-1.12 1.766-1.644 3.761-1.51 5.764 0 .26.12.508.336.691.216.183.508.287.812.287.305 0 .597-.104.813-.287a.91.91 0 00.336-.69l-.012-.009z"
    />
  </svg>
);

WaveIcon.propTypes = {
  className: PropTypes.string,
};

WaveIcon.defaultProps = {
  className: '',
};

export const TriangleFillIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="29"
    viewBox="0 0 27 29"
    fill="none"
    className={className}
  >
    <path
      fill="#00D6C8"
      d="M2.669 5.26c.525-3.814 4.98-5.63 8.02-3.269l14.164 11c3.04 2.36 2.384 7.127-1.18 8.58L7.065 28.336c-3.564 1.452-7.364-1.499-6.84-5.312L2.67 5.259z"
      opacity="0.5"
      viewBox="0 0 27 29"
    />
  </svg>
);

TriangleFillIcon.propTypes = {
  className: PropTypes.string,
};

TriangleFillIcon.defaultProps = {
  className: '',
};

export const CirclesLineIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    className={className}
  >
    <circle cx="5.5" cy="5.5" r="5" stroke="#3E3E3E" />
    <circle cx="23.5" cy="26.5" r="3" stroke="#3E3E3E" />
    <path stroke="#3E3E3E" d="M7.657 17.636l17-16" />
  </svg>
);

CirclesLineIcon.propTypes = {
  className: PropTypes.string,
};

CirclesLineIcon.defaultProps = {
  className: '',
};

export const CrossLinesIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    className={className}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
      d="M1.099 1.239L8.34 8.48m9.19 9.18l7.23 7.24m.141-23.801L17.66 8.34m-9.18 9.19l-7.24 7.23"
    />
  </svg>
);

CrossLinesIcon.propTypes = {
  className: PropTypes.string,
};

CrossLinesIcon.defaultProps = {
  className: '',
};

export const HalfCircleIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
    className={className}
  >
    <path
      stroke="#FF7E4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="10"
      d="M5.878 7.59a25.07 25.07 0 018.72-2.095 25.423 25.423 0 018.947 1.082c2.873.888 5.522 2.279 7.795 4.092 2.272 1.813 4.123 4.012 5.445 6.472a19.051 19.051 0 012.257 7.856 18.773 18.773 0 01-1.278 8.033c-1.012 2.576-2.58 4.945-4.617 6.973-2.035 2.028-4.497 3.673-7.244 4.84"
    />
  </svg>
);

HalfCircleIcon.propTypes = {
  className: PropTypes.string,
};

HalfCircleIcon.defaultProps = {
  className: '',
};

export const CircleLinesYellowIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="86"
    height="56"
    viewBox="0 0 86 56"
    fill="none"
    className={className}
  >
    <path
      fill="#FD0"
      d="M62.98 46.042C75.692 46.042 86 35.735 86 23.02S75.693 0 62.98 0C50.264 0 39.957 10.307 39.957 23.02c0 12.715 10.307 23.022 23.021 23.022z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
      d="M44.42 12.183L1.78 54.825M62.384 9.28L19.742 51.92"
    />
  </svg>
);

CircleLinesYellowIcon.propTypes = {
  className: PropTypes.string,
};

CircleLinesYellowIcon.defaultProps = {
  className: '',
};

export const CircleLinesIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="40"
    viewBox="0 0 35 40"
    fill="none"
    className={className}
  >
    <path
      stroke="#3E3E3E"
      d="M.696 39.603l21.052-16.14M.696 28.375l21.052-16.14"
    />
    <circle cx="30" cy="5" r="4.5" stroke="#000" />
  </svg>
);

CircleLinesIcon.propTypes = {
  className: PropTypes.string,
};

CircleLinesIcon.defaultProps = {
  className: '',
};
